// Auth
export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
export const SIGNIN_FAILED = "SIGNIN_FAILED";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAILED = "SIGNUP_FAILED";
export const SIGNOUT = "SIGNOUT";
export const LOGGED_OUT = "LOGGED_OUT";

// Hire
export const IS_ACTIVE = "IS_ACTIVE";
export const NOT_ACTIVE = "NOT_ACTIVE";
export const FETCH_WORK_ORDER = "FETCH_WORK_ORDER";

// Job
export const APPLIED = "APPLIED";
export const NOT_APPLIED = "NOT_APPLIED";

// Posters
export const FETCH_MY_POSTERS = "FETCH_MY_POSTERS";
export const RESET_POSTERS = "RESET_POSTERS";

// Profile
export const FETCH_PROFILE = "FETCH_PROFILE";
export const PROFILE_NOT_FOUND = "PROFILE_NOT_FOUND";
export const RESET_PROFILE = "RESET_PROFILE";

// Notifications
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const RESET_NOTIFICATIONS = "RESET_NOTIFICATIONS";
